<article>
	<header>
		<h3>
			{{ 'adminstat.common.Testing' | translate }}
		</h3>
	</header>
	
	<section>
		<cache-date></cache-date>
	</section>
	
	<section>
		<div class="row">
			<div class="col-md-3">
				<label>{{ 'adminstat.common.language' | translate }}</label>
				<select class="form-control" [(ngModel)]="lng" [ngModelOptions]="{standalone: true}">
					<option *ngFor="let opt of localesMap | keys" value="{{ opt }}" [selected]="opt == lng">{{ localesMap[opt] }}
					</option>
				</select>
			</div>
			<div class="col-md-9">
				<label>{{ 'adminstat.common.Email' | translate }}</label>
				<input type="text" class="form-control" name="email" [(ngModel)]="authService.email" [ngModelOptions]="{standalone: true}" />
			</div>
		</div>
		
		<hr/>
	</section>
	
	<section>
		<div
			class="row"
			*ngFor="let tab of mailTabGroups"
		>
			<div class="col-md-12">
				{{ tab.tab }}
			</div>
			
			<div class="col-md-12">
				<div
					class="row offset-md-1 mb-2"
					*ngFor="let group of tab.groups"
				>
					<div class="col-md-2">
						{{ group.group }}
					</div>
					
					<div class="col-md-10">
						<button
							type="button" class="btn btn-success mr-1 mb-1"
							*ngFor="let subjectType of group.subjectTypes"
							(click)="sendTest(subjectType)"
						>
							{{ 'adminstat.mails.mail.' + subjectType | translate }} ({{ subjectType }})
						</button>

					</div>
				</div>
			</div>
		</div>
	</section>
</article>


<ng-template #modalProgress let-modal>
	<div class="modal-header">
		Отправка письма
	</div>
	
	<div class="modal-body">
		<ng-container *ngIf="inProgress">
			<ngb-progressbar type="primary" [value]="100" [striped]="true" [animated]="true"></ngb-progressbar>
		</ng-container>
		
		<ng-container *ngIf="!inProgress">
			<ngb-alert type="primary" [dismissible]="false">{{resultMessage}}</ngb-alert>
		</ng-container>	
	</div>
	
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-primary" (click)="modal.close('close')">Закрыть</button>		
	</div>
</ng-template>
